import { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { StoreState, LandlordBuilding } from '@root/types';
import { TabPane, BuildingCard } from '@components/shared';
import { Trans } from 'react-i18next';
import { saveBuilding, unsaveBuilding } from '@store/actions/saved/building';
import actions from '@store/actions/saved';
import { isBuildingSaved } from '@store/selectors';
import Layout from '../Layout';
import favoriteStyles from './Buildings.module.less';

const mapState = (state: StoreState) => ({
  savedBuildings: state.savedBuildings.byId,
  isSaved: (buildingId: string) => isBuildingSaved(state, null, buildingId),
});

const mapDispatch = {
  handleSaveBuilding: (id: string, slug: string) => saveBuilding(id, slug),
  handleUnsaveBuilding: (id: string, slug: string) => unsaveBuilding(id, slug),
  loadPage: () => actions.loadSavedBuildingsPage(),
  clickSavedBuilding: () => actions.savedBuildingClick(),
};

const connector = connect(mapState, mapDispatch);
type ReduxProps = ConnectedProps<typeof connector>;

export const RawSavedBuildings = ({
  handleSaveBuilding,
  handleUnsaveBuilding,
  savedBuildings,
  loadPage,
  isSaved,
  clickSavedBuilding,
}: ReduxProps) => {
  useEffect(() => {
    loadPage();
  }, []);

  const count = Object.keys(savedBuildings).length;

  return (
    <Layout active="buildings">
      <TabPane key="buildings">
        <h1 className={favoriteStyles.title}>
          <Trans i18nKey="favorites:numSavedBuildings" count={count}>
            <span className="u-translation--bold">{{ count }}</span>
          </Trans>
        </h1>
        <ul className={favoriteStyles.cardList}>
          {Object.keys(savedBuildings).map(buildingId => {
            const building: LandlordBuilding = savedBuildings[buildingId];

            return (
              <li key={building.id}>
                <BuildingCard
                  onSave={handleSaveBuilding}
                  onUnsave={handleUnsaveBuilding}
                  isSaved={isSaved(building.id)}
                  showSaveButton
                  building={building}
                  onBuildingClick={clickSavedBuilding}
                  minimal
                />
              </li>
            );
          })}
        </ul>
      </TabPane>
    </Layout>
  );
};

export default connector(RawSavedBuildings);
